/**
 * Best-effort UI haptics via the Vibration API (common on Android Chrome).
 * iOS Safari typically does not expose vibrate — calls are no-ops after checks.
 */

/** Phones / tablets / touch-primary UIs — not a typical mouse-first desktop. */
function isMobileLikeTouchDevice(): boolean {
  if (typeof window === "undefined") return false;
  try {
    if (window.matchMedia("(pointer: coarse)").matches) return true;
    if (
      typeof navigator !== "undefined" &&
      navigator.maxTouchPoints > 0 &&
      window.matchMedia("(hover: none)").matches
    ) {
      return true;
    }
  } catch {
    /* noop */
  }
  return false;
}

function vibrateSupported(): boolean {
  return (
    typeof navigator !== "undefined" &&
    typeof navigator.vibrate === "function"
  );
}

/** Short pulse for buttons / toggles; no-op when unavailable or not a mobile-like device. */
export function playUiHaptic(kind: "light" | "medium" = "light"): void {
  if (!isMobileLikeTouchDevice() || !vibrateSupported()) return;
  const ms = kind === "medium" ? 28 : 14;
  try {
    navigator.vibrate(ms);
  } catch {
    /* noop */
  }
}
